import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

interface BlockLoaderProps {
    text?: string;
}

export const BlockLoader: FC<BlockLoaderProps> = ({ text }) => {
    return (
        <Flex vertical justify="center" align="center" gap="16px">
            {text && <PrimaryText>{text}</PrimaryText>}

            <Spin size="large" indicator={<LoadingOutlined spin />} />
        </Flex>
    );
};
